module.exports = __webpack_public_path__ + "img/doc-cycle.f48e5614.svg";